import { GenericHelpers } from '../../utilities/luigi-generic.helper';
import { Injectable } from '@angular/core';
import { ClientEnvironment, LuigiNode } from '@openmfp/portal-ui-lib';

const PLUGIN_HANDLING_PATH = '/no-plugin-handling';

@Injectable({
  providedIn: 'root',
})
export class PluginHandlingService {
  public pluginHandling(
    node: LuigiNode,
    clientEnvironment: ClientEnvironment,
  ): LuigiNode {
    const _clientEnvironment = clientEnvironment as ClientEnvironment & {
      minimalPluginVersion: number;
    };
    const pluginVersion = document.documentElement.getAttribute(
      '_luigiBrowserPluginVersion',
    );

    const pluginAvailable = !!pluginVersion;

    if (pluginAvailable) {
      const currentMajorVersion = this.getMajorVersion(pluginVersion);
      if (currentMajorVersion < _clientEnvironment['minimalPluginVersion']) {
        return this.convertToNoPluginHandlingNode(
          node,
          currentMajorVersion,
          _clientEnvironment['minimalPluginVersion'],
        );
      }

      this.sendEventToPlugin(node);
      return node;
    }

    return this.convertToNoPluginHandlingNode(node);
  }

  private getMajorVersion(version: string): number {
    const exec = /(\d+)\.\d+\.\d+/.exec(version);
    if (!exec || !exec[1]) {
      return 1;
    }

    return parseInt(exec[1]);
  }

  private sendEventToPlugin(node: LuigiNode) {
    const viewUrl = GenericHelpers.replaceVars(
      node.viewUrl ?? '',
      node.context,
      'context.',
    );
    window.postMessage(
      {
        url: viewUrl,
        type: 'dxp.browser.extension.event',
      },
      location.origin,
    );
  }

  private convertToNoPluginHandlingNode(
    originalNode: LuigiNode,
    majorVersion?: number,
    minimalPluginVersion?: number,
  ): LuigiNode {
    const viewUrl = originalNode.viewUrl;
    return Object.assign({}, originalNode, {
      viewUrl: PLUGIN_HANDLING_PATH,
      context: {
        ...originalNode.context,
        label: originalNode.label,
        url: viewUrl,
        isOutdated: !isNaN(majorVersion as number),
        currentVersion: majorVersion,
        requiredVersion: minimalPluginVersion,
      },
      visibleForPlugin: undefined,
      isMissingMandatoryData: undefined,
      children: [],
      networkVisibility: undefined,
      isolateView: true,
      loadingIndicator: { enabled: false },
    });
  }
}
